import ru from '../localization/ru';

const COUNTRY_LIST = ru.message.signUp.livingAddressBlock.country.countryList;

function getCountryName(code) {
    const key = String(code);
    return COUNTRY_LIST[key] || code;
}

function canRegisterAsBorrower(data) {
    const citizenship = String(data?.citizenship || '');
    const documentSeries = data?.id_document?.series || '';

    return citizenship === '112' && documentSeries !== 'PP';
}

function getSignUpDisabledFields(data) {
    return {
        phone_number: !!data.phone_number,
        email: !!data.email,
        family_name_ru: !!data.name_ru.family_name_ru,
        given_name_ru: !!data.name_ru.given_name_ru,
        middle_name_ru: !!data?.name_ru?.middle_name_ru,
        birthdate: !!data.birthdate,
        sex: !!data.sex,
        birth_place_str: !!data.birth_place_str,
        citizenship: !!data.citizenship,
        national_id_number: !!data.national_id_number,
        type: !!data.id_document.type,
        seriesNumber: !!data.id_document.seriesNumber,
        issueDate: !!data.id_document.issueDate,
        expireDate: !!data.id_document.expireDate,
        authority: !!data.id_document.authority,
        address_str: !!data.address_str
    }
}

function getEmptyLivingAddress() {
    return {
        country: '',
        region: '',
        district: '',
        locality_type: '',
        locality: '',
        street_type: '',
        street: '',
        house: '',
        building: '',
        apartment: '',
        postal_code: '',
    };
}

function getParsedAddress(data) {
    const address = data.address;
    const country = address.country ? `${getCountryName(address.country)},` : '';
    const locality = address.locality ? `${address.locality},` : '';
    const house = address.house ? `дом ${address.house},` : '';
    const building = address.building ? `строение ${address.building},` : '';
    const apartment = address.apartment ? `квартира ${address.apartment}` : '';
    const address_str = `${address.postal_code} ${country} ${address.locality_type} ${locality} ${address.street_type} ${address.street} ${house} ${building} ${apartment}`;
    return address_str;
}

export {
    getSignUpDisabledFields,
    getEmptyLivingAddress,
    getParsedAddress,
    canRegisterAsBorrower,
};